import moment from "moment";
export const getCurrentDate = () => moment();
export const fetchFormattedDate = (date?: string) =>
  moment(date).format("MM/DD/YYYY");

export const timeStampToDocumentDate = (timeStamp?: string) =>
  moment.unix(timeStamp).format("MMM D, YYYY");
